export const catTipoCambio = {
    NoAplica: 0,
    PESOS: 1,
    DOLARES: 2,
    EUROS: 3,
}